var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5646_426)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5646_426",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0V128H128V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5646_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.2565 34.2565L81.7435 18.7435C80.6935 17.6935 79 17.5 79 17.5H35.5C32.2 17.5 29.5 20.2 29.5 23.5V104.5C29.5 107.8 32.2 110.5 35.5 110.5H92.5C95.8 110.5 98.5 107.8 98.5 104.5V37C98.5 37 98.3065 35.3065 97.2565 34.2565Z",
    fill: "#E7EBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2565 34.2565L81.7435 18.7435C80.6935 17.6935 79 17.5 79 17.5V31C79 34.3 81.7 37 85 37H98.5C98.5 37 98.3065 35.3065 97.2565 34.2565Z",
    fill: "#00B495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5 77.5C83.5 79.15 82.15 80.5 80.5 80.5H47.5C45.85 80.5 44.5 79.15 44.5 77.5V50.5C44.5 48.85 45.85 47.5 47.5 47.5H80.5C82.15 47.5 83.5 48.85 83.5 50.5V77.5Z",
    fill: "#00A7E4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 58C53.6568 58 55 56.6568 55 55C55 53.3432 53.6568 52 52 52C50.3432 52 49 53.3432 49 55C49 56.6568 50.3432 58 52 58Z",
    fill: "#D1E7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 58L44.5 77.5C44.5 79.15 45.85 80.5 47.5 80.5H56.5L71.5 65.5L64 58Z",
    fill: "#00B495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 80.5H80.5C82.15 80.5 83.5 79.15 83.5 77.5V68.5L76 61L56.5 80.5Z",
    fill: "#00B495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.991 36.829C99.964 36.6025 99.697 34.576 98.3185 33.196L82.804 17.683C81.4255 16.303 79.3975 16.036 79.171 16.0105C79.114 16.003 79.057 16 79 16H35.5C31.3645 16 28 19.3645 28 23.5V104.5C28 108.635 31.3645 112 35.5 112H92.5C96.6355 112 100 108.635 100 104.5V37C100 36.943 99.997 36.886 99.991 36.829ZM96.196 35.317C96.2485 35.3695 96.286 35.44 96.3325 35.5H85C82.519 35.5 80.5 33.481 80.5 31V19.6675C80.56 19.714 80.629 19.7515 80.683 19.804L96.196 35.317ZM92.5 109H35.5C33.019 109 31 106.981 31 104.5V23.5C31 21.019 33.019 19 35.5 19H77.5V31C77.5 35.1355 80.8645 38.5 85 38.5H97V104.5C97 106.981 94.981 109 92.5 109Z",
    fill: "#334D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 46H47.5C45.019 46 43 48.019 43 50.5V77.5C43 79.981 45.019 82 47.5 82H80.5C82.981 82 85 79.981 85 77.5V50.5C85 48.019 82.981 46 80.5 46ZM47.5 49H80.5C81.3265 49 82 49.6735 82 50.5V64.879L77.0605 59.9395C76.474 59.353 75.526 59.353 74.9395 59.9395L71.5 63.379L65.0605 56.9395C64.474 56.353 63.526 56.353 62.9395 56.9395L46 73.879V50.5C46 49.6735 46.6735 49 47.5 49ZM46.105 78.016L64 60.121L69.379 65.5L55.879 79H47.5C46.8565 79 46.3165 78.5875 46.105 78.016ZM80.5 79H60.121L76 63.121L82 69.121V77.5C82 78.3265 81.3265 79 80.5 79Z",
    fill: "#334D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 59.5C54.481 59.5 56.5 57.481 56.5 55C56.5 52.519 54.481 50.5 52 50.5C49.519 50.5 47.5 52.519 47.5 55C47.5 57.481 49.519 59.5 52 59.5ZM52 53.5C52.8265 53.5 53.5 54.1735 53.5 55C53.5 55.8265 52.8265 56.5 52 56.5C51.1735 56.5 50.5 55.8265 50.5 55C50.5 54.1735 51.1735 53.5 52 53.5Z",
    fill: "#334D87"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5646_426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/Placeholder.9190514bf3618d3b31d7c7d74bbb6599.svg";
export { ForwardRef as ReactComponent };